import { jsx as _jsx } from "react/jsx-runtime";
import { PurPurButton } from 'components/button';
import styled from 'styled-components';
const StyledLink = styled.a `
  color: inherit;
  text-decoration: none;
`;
export const GoogleMapsButton = ({ address, onClose }) => {
    const buildDestinationQuery = (address) => {
        const { street, houseNumberNumeric, houseNumberAlpha, postalCode, city, } = address;
        const parts = [];
        if (street) {
            const number = [houseNumberNumeric, houseNumberAlpha].filter(Boolean).join('');
            parts.push(number ? `${street} ${number}` : street);
        }
        if (postalCode)
            parts.push(String(postalCode));
        if (city)
            parts.push(String(city));
        const destination = parts.join(', ').trim();
        const params = new URLSearchParams({
            api: '1',
            destination,
            travelmode: 'driving',
        });
        return `https://www.google.com/maps/dir/?${params.toString()}`;
    };
    const isAddressValid = Boolean((address === null || address === void 0 ? void 0 : address.street) && (address === null || address === void 0 ? void 0 : address.city));
    const href = isAddressValid ? buildDestinationQuery(address) : undefined;
    return (_jsx(PurPurButton, { variant: 'primary', disabled: !isAddressValid, onClick: onClose, children: _jsx(StyledLink, { target: "_blank", rel: "noopener noreferrer", href: href, children: "\u00C5pne kart" }) }));
};
